var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "label",
        {
          staticClass: "col-sm-3 font-weight-bold col-form-label",
          attrs: { for: _vm.id }
        },
        [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
          _vm.isRequired && !_vm.isDisabled ? _c("required-label") : _vm._e(),
          _vm._v(" "),
          _vm.info
            ? _c("font-awesome-icon", {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.info,
                    expression: "info"
                  }
                ],
                staticClass: "text-primary ml-1",
                attrs: { icon: ["fad", "info-circle"] }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.$v.selectedAdres.$invalid
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-danger" }, [
                  _vm._v("Ongeldig")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isNew
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-success" }, [
                  _vm._v("Nieuw")
                ])
              ])
            : _vm.isDirty
            ? _c("transition", { attrs: { name: "fade" } }, [
                _c("span", { staticClass: "badge badge-warning" }, [
                  _vm._v("Aangepast")
                ])
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-4" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedAdres.straat,
              expression: "selectedAdres.straat"
            }
          ],
          class: [
            _vm.$v.selectedAdres.straat.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            id: _vm.id,
            type: "text",
            disabled: _vm.isDisabled == true,
            placeholder: _vm.labels.contact.woonplaats.straat,
            required: _vm.required
          },
          domProps: { value: _vm.selectedAdres.straat },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.selectedAdres, "straat", $event.target.value)
              },
              _vm.updateAdres
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedAdres.nr,
              expression: "selectedAdres.nr"
            }
          ],
          class: [
            _vm.$v.selectedAdres.nr.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            disabled: _vm.isDisabled == true,
            type: "text",
            placeholder: _vm.labels.contact.woonplaats.nr,
            required: _vm.required
          },
          domProps: { value: _vm.selectedAdres.nr },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.selectedAdres, "nr", $event.target.value)
              },
              _vm.updateAdres
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedAdres.bus,
              expression: "selectedAdres.bus"
            }
          ],
          class: [
            _vm.$v.selectedAdres.bus.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            disabled: _vm.isDisabled == true,
            type: "text",
            placeholder: _vm.labels.contact.woonplaats.bus
          },
          domProps: { value: _vm.selectedAdres.bus },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.selectedAdres, "bus", $event.target.value)
              },
              _vm.updateAdres
            ]
          }
        })
      ]),
      _vm._v(" "),
      _vm.showDelete && !_vm.isDisabled
        ? _c(
            "div",
            { staticClass: "col-sm-1" },
            [_c("delete-button", { on: { click: _vm.deleteAddress } })],
            1
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-3" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedAdres.hfdPostnr,
              expression: "selectedAdres.hfdPostnr"
            }
          ],
          class: [
            _vm.$v.selectedAdres.hfdPostnr.$invalid ? "is-invalid" : "",
            "form-control"
          ],
          attrs: {
            disabled: _vm.isDisabled == true,
            type: "text",
            placeholder: _vm.labels.contact.woonplaats.hfdPostnr,
            required: _vm.required
          },
          domProps: { value: _vm.selectedAdres.hfdPostnr },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.selectedAdres, "hfdPostnr", $event.target.value)
              },
              _vm.updateAdres
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-3" },
        [
          !_vm.isInBelgium
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selectedAdres.deelgemeente,
                    expression: "selectedAdres.deelgemeente"
                  }
                ],
                class: [
                  _vm.$v.selectedAdres.deelgemeente.$invalid
                    ? "is-invalid"
                    : "",
                  "form-control"
                ],
                attrs: {
                  disabled: _vm.isDisabled == true,
                  type: "text",
                  placeholder: _vm.labels.contact.woonplaats.deelgemeente,
                  required: _vm.required
                },
                domProps: { value: _vm.selectedAdres.deelgemeente },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.selectedAdres,
                        "deelgemeente",
                        $event.target.value
                      )
                    },
                    _vm.updateAdres
                  ]
                }
              })
            : _c("city-input", {
                attrs: {
                  "is-disabled": _vm.isDisabled,
                  placeholder: "Gemeente"
                },
                on: { input: _vm.updateAdres },
                model: {
                  value: _vm.selectedAdres.deelgemeente,
                  callback: function($$v) {
                    _vm.$set(_vm.selectedAdres, "deelgemeente", $$v)
                  },
                  expression: "selectedAdres.deelgemeente"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-sm-3" },
        [
          _c("country-input", {
            attrs: { "is-disabled": _vm.isDisabled, placeholder: "Land" },
            on: { input: _vm.updateAdres },
            model: {
              value: _vm.selectedAdres.land,
              callback: function($$v) {
                _vm.$set(_vm.selectedAdres, "land", $$v)
              },
              expression: "selectedAdres.land"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "row" },
      [
        _c("div", { staticClass: "col-sm-3" }),
        _vm._v(" "),
        _vm.isNew
          ? _c("date-input", {
              staticClass: "col-sm-4",
              attrs: {
                "is-disabled": _vm.isDisabled,
                placeholder: "Ingangsdatum",
                "is-dirty": false
              },
              on: { input: _vm.updateAdres },
              model: {
                value: _vm.selectedAdres.ingangsDatum,
                callback: function($$v) {
                  _vm.$set(_vm.selectedAdres, "ingangsDatum", $$v)
                },
                expression: "selectedAdres.ingangsDatum"
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }